import { useContext } from 'react'
import { LanguageContext } from './languageContext'

export const useLanguageContext = () => useContext(LanguageContext)
